module.exports = __webpack_public_path__ + "img/1280x720-Day.1e35a184.jpg";